window.addEventListener("DOMContentLoaded", (event) => {
  class PrimitivesValidator {
    static validateString(string) {
      if (!string) throw new Error("No argument was provided");
      const isString = typeof string === "string";

      if (!isString) throw new Error("Element is not a string");

      const isEmpty = string.trim().length === 0;
      if (isEmpty) throw new Error("String can not be empty");

      return;
    }
  }

  class ContactInputValidator {
    static validateInputInstance(id) {
      PrimitivesValidator.validateString(id);

      const input = document.getElementById(`${id}`);
      const isInstanceOfHTMLInput = input instanceof HTMLInputElement;
      const isInstanceOfTextarea = input instanceof HTMLTextAreaElement;

      if (!isInstanceOfHTMLInput && !isInstanceOfTextarea)
        throw new Error(
          `Found element is neither an HTML Input text or Textarea element.`
        );
      return;
    }

    static validateLabel(labelId) {
      PrimitivesValidator.validateString(labelId);
      const label = document.getElementById(`${labelId}`);

      if (!label) throw new Error(`No label of id ${labelId} was found`);

      const isLabelInstance = label instanceof HTMLLabelElement;
      if (!isLabelInstance) throw new Error("Element is not a label.");
      return;
    }
  }

  class ContactInput {
    constructor(id ) {
      PrimitivesValidator.validateString(id);

      this.id = id;
      this.element = null;
      this.errorClass = "input--error";
      this.label = null;
      this.labelErrorClass = "label--error";
      this.value = "";
      this.isValid = false;
      this.initiate();
    }

    _getInput() {
      const contactInput = document.getElementById(`${this.id}`);
      this.element = contactInput;

      return;
    }


    _blur(event) {
      const wasTouched = this.touched;
      if (!wasTouched) this.touched = true;
      const value = event.target.value;
      this._setValue(value);
      this.validate();
    }

    _focus() {
      this.removeError();
      return;
    }

    addBlur() {
      this.element.addEventListener("blur", this._blur.bind(this));
    }

    addFocus() {
      this.element.addEventListener("focus", this._focus.bind(this));
    }

    initiate() {
      this._getInput();
      this.addBlur();
      this.addFocus();
    }

    _setValue(value) {
      this.value = value;
      return;
    }

    reset() {
      this.isValid = false;
      this.value;
      this.element.value = "";
    }

    validate() {
      const isValid = this.value.trim().length > 0;

      this.isValid = isValid;
      if (!this.isValid) this.addError();

      return;
    }

    addError() {
      this.element.classList.add(`${this.errorClass}`);
        return;
    }

    removeError() {
      const isInputErrorActive = this.element.classList.contains(
        `${this.errorClass}`
      );

      if (isInputErrorActive)
        this.element.classList.remove(`${this.errorClass}`);
      return;
    }
  }

  class ConditionalInputValidator extends ContactInputValidator {
    static validateInputContainer(inputContainerId) {
      PrimitivesValidator.validateString(inputContainerId);

      const container = document.getElementById(`${inputContainerId}`);
      if (!container) throw new Error("No element was found.");
      return;
    }
  }

  class ConditionalInput extends ContactInput {
    constructor(id, containerId, containerInactiveClass) {
      super(id);
      this.isActive = false;

      PrimitivesValidator.validateString(containerInactiveClass);
      this.inactiveClass = containerInactiveClass;

      PrimitivesValidator.validateString(containerId);
      this.containerId = containerId;

      ConditionalInputValidator.validateInputContainer(this.containerId);
      this.container = null;
      this.getContainer();
    }

    hide() {
      if (!this.isActive) return;

      this.container.classList.add(`${this.inactiveClass}`);
      this.reset();
      this.isActive = false;
      return;
    }

    appear() {
      if (this.isActive) return;

      this.container.classList.remove(`${this.inactiveClass}`);
      this.isActive = true;
      this.element.focus();
      return;
    }

    getContainer() {
      const container = document.getElementById(`${this.containerId}`);
      this.container = container;
    }
  }

  class SelectDropdownValidator {
    static validateRadioButtons(className) {
      PrimitivesValidator.validateString(className);

      const radioButtons = document.querySelectorAll(`.${className}`);

      radioButtons.forEach((button) => {
        if (!button) throw new Error("No radio button was found.");
      });
      return;
    }

    static validateSelectDropdown(id) {
      PrimitivesValidator.validateString(id);

      const selectDropdown = document.getElementById(`${id}`);
      if (!selectDropdown) throw new Error(`No element of ${id} was found`);
      return;
    }
  }

  class SelectDropdown {
    constructor(radioButtonsClassName, selectDropdownId) {
      PrimitivesValidator.validateString(radioButtonsClassName);
      PrimitivesValidator.validateString(selectDropdownId);
      SelectDropdownValidator.validateRadioButtons(radioButtonsClassName);
      SelectDropdownValidator.validateSelectDropdown(selectDropdownId);

      this.radioButtonsClassName = radioButtonsClassName;
      this.selectDropdownId = selectDropdownId;
      this.selectInactiveClass = "inactive";
      this.radioButtons = [];
      this.isClosed = true;
      this.isValid = false;
      this.value = "";
      this.selectDropdown = null;
      this.initiate();
    }

    _getRadioButtons() {
      const radioButtons = document.querySelectorAll(
        `.${this.radioButtonsClassName}`
      );
      radioButtons.forEach((button) => {
        const isButtonAlreadyIncluded = this.radioButtons.indexOf(button) > -1;
        if (isButtonAlreadyIncluded) return;

        this.radioButtons.push(button);

        return;
      });
    }

    _getSelectDropdown() {
      const selectDropdown = document.getElementById(
        `${this.selectDropdownId}`
      );

      this.selectDropdown = selectDropdown;
      return;
    }

    _checkRadio(event) {
      const radioValue = event.target.value;
      this.value = radioValue;
      this.isValid = true;
      this.closeDropdown();
    }

    handleRadioCheck() {
      this.radioButtons.forEach((radioButton) => {
        try {
          radioButton.addEventListener("click", this._checkRadio.bind(this));
        } catch (error) {
          console.error(error);
        }
      });
      return;
    }

    initiate() {
      this._getRadioButtons();
      this._getSelectDropdown();
      this.handleRadioCheck();
      return;
    }

    openDropdown() {
      this.selectDropdown.classList.remove(`${this.selectInactiveClass}`);
      this.isClosed = false;
      return;
    }

    closeDropdown() {
      this.selectDropdown.classList.add(`${this.selectInactiveClass}`);
      this.isClosed = true;
      return;
    }

    toggle() {
      const isDropdownClosed = this.selectDropdown.classList.contains(
        `${this.selectInactiveClass}`
      );
      if (isDropdownClosed) {
        this.openDropdown();
        return;
      }
      this.closeDropdown();
      return;
    }
  }

  const selectData = {
    valueId: "selectValue",
    valueContainerId: "selectValueContainer",
    containerId: "selectContainer",
  };

  class SelectValidator {
    static validateDropdown(dropdown) {
      const isSelectDropdownInstance = dropdown instanceof SelectDropdown;

      if (!isSelectDropdownInstance)
        throw new Error("Dropdown has to be SelectDropdown instance");
      return;
    }

    static validateConditionalInput(conditionalInput) {
      const isConditionalInputInstance =
        conditionalInput instanceof ConditionalInput;

      if (!isConditionalInputInstance)
        throw new Error("Dropdown has to be ConditionalInput instance");
      return;
    }

    static validateValue(id) {
      PrimitivesValidator.validateString(id);

      const selectValue = document.getElementById(`${id}`);

      if (!selectValue) throw new Error("No select value was found");
      return;
    }

    static validateSelectData(selectData) {
      const isObject =
        Object.prototype.toString.call(selectData) === "[object Object]";

      if (!isObject) throw new Error("Select data has to be an object");

      const mandatoryDataKeys = [
        "valueId",
        "valueContainerId",
        "containerId",
      ];
      const mandatoryKeysNumber = mandatoryDataKeys.length;
      const dataKeys = Object.keys(selectData);
      const dataKeysNumber = dataKeys.length;

      if (dataKeysNumber < mandatoryKeysNumber)
        throw new Error("Select data must include four keys.");

      const isKeyAbsent = (key) => dataKeys.indexOf(key) === -1;

      const isSomeKeyNotIncluded = mandatoryDataKeys.some((key) =>
        isKeyAbsent(key)
      );

      if (isSomeKeyNotIncluded)
        throw new Error(
          "Select data must include four keys: valueId, valueContainerId, labelId, containerId."
        );
      return;
    }

    static validateHTMLElement(id) {
      PrimitivesValidator.validateString(id);

      const element = document.getElementById(`${id}`);
      if (!element) console.error(`No element of ${id} was found`);

      const isHTMLElement = element instanceof HTMLElement;

      if (!isHTMLElement)
        throw new Error(`Element of id ${id} is not HTML element`);
      return;
    }
  }

  class Select {
    constructor(dropdown, conditionalInput, selectData) {
      SelectValidator.validateDropdown(dropdown);
      SelectValidator.validateConditionalInput(conditionalInput);
      SelectValidator.validateSelectData(selectData);
      SelectValidator.validateHTMLElement(selectData.valueId);
      SelectValidator.validateHTMLElement(selectData.containerId);
      SelectValidator.validateHTMLElement(selectData.valueContainerId);

      this.dropdown = dropdown;
      this.conditionalInput = conditionalInput;
      this.data = selectData;
      this.isValid = false;
      this.value = null;
      this.labelErrorClass = "label--error";
      this.container = null;
      this.valueContainer = null;
      this.id = selectData.valueContainerId;
      this.valueContainerErrorClass = "input--error";
      this.containerActiveClass = "active";
      this.initiateSelect();
    }

    initiateSelect() {
      try {
        this._setValue();
        this._setContainer();
        this._setValueContainer();
        this.handleClick();
        this.handleDropdownRadioCheck();
        this._addClickOutside();
      } catch (error) {
        console.error(error);
      }
    }

    _setValue() {
      const selectValue = document.getElementById(`${this.data.valueId}`);
      this.value = selectValue;
    }

    _setContainer() {
      const container = document.getElementById(`${this.data.containerId}`);
      this.container = container;
      return;
    }

    _setValueContainer() {
      const valueContainer = document.getElementById(
        `${this.data.valueContainerId}`
      );
      this.valueContainer = valueContainer;
      return;
    }

    _click() {
      this.removeError();

      if (this.dropdown.isClosed) {
        this.valueContainer.classList.add(`${this.containerActiveClass}`);
        this.dropdown.openDropdown();
      } else {
        if (this.value.innerHTML !== "Select") this.isValid = true;
        this.valueContainer.classList.remove(`${this.containerActiveClass}`);
        this.dropdown.closeDropdown();

        if (this.value.innerHTML === "Select") this.addError();
      }
      return;
    }

    _updateValue() {
      this.value.innerHTML = this.dropdown.value;
      if (!this.isValid) this.isValid = true;
      this.toggleInputVisibility();
      this.valueContainer.classList.toggle(`${this.containerActiveClass}`);
      return;
    }

    _handleClickOutside(event) {
      const valueContainerClasslist = this.valueContainer.classList;
      const isSelectActive = this.valueContainer.classList.contains(
        `${this.containerActiveClass}`
      );

      const isOutsideClick = !this.container.contains(event.target);

      if (!isSelectActive) return;
      if (!isOutsideClick) return;

      valueContainerClasslist.remove(`active`);
      this.dropdown.closeDropdown();

      if (this.value.innerHTML !== "Select") return;
      this.addError();
    }

    _addClickOutside() {
      document.addEventListener("click", this._handleClickOutside.bind(this));
      return;
    }

    reset() {
      this.value.innerHTML = "Select";
      this.isValid = false;
      return;
    }

    handleClick() {
      this.valueContainer.addEventListener("click", this._click.bind(this));
    }

    removeError() {
      this.valueContainer.classList.remove(`${this.valueContainerErrorClass}`);
      return;
    }

    addError() {
      this.valueContainer.classList.add(`${this.valueContainerErrorClass}`);
      this.valueContainer.classList.remove(`${this.containerActiveClass}`);
      return;
    }

    toggleInputVisibility() {
      const shouldAdditionalInputAppear = this.value.innerHTML === "Other";

      if (!shouldAdditionalInputAppear) {
        this.conditionalInput.hide();
        return;
      }
      this.conditionalInput.appear();
    }

    handleDropdownRadioCheck() {
      this.dropdown.radioButtons.forEach((button) => {
        button.addEventListener("click", this._updateValue.bind(this));
      });
      return;
    }
  }

  class ContactFormValidator {
    static validateFormElementsData(formElementsData) {
      const isObject =
        Object.prototype.toString.call(formElementsData) === "[object Object]";

      if (!isObject) throw new Error("Form elements data must be an object");

      const mandatoryFormElementsKeys = [
        "formName",
        "formEmail",
        "formMessage",
        "select",
        "buttonId",
        "successMessageId",
        "errorMessageId",
      ];
      const formElementsKeys = Object.keys(formElementsData);

      const isKeyMissing = (key) => formElementsKeys.indexOf(key) === -1;
      const isAnyMandatoryKeyMissing = mandatoryFormElementsKeys.some((key) =>
        isKeyMissing(key)
      );

      if (isAnyMandatoryKeyMissing)
        throw new Error("Form elements argument is missing a key");

      const stringFields = ["successMessageId", "errorMessageId", "buttonId"];

      stringFields.forEach((field) => {
        PrimitivesValidator.validateString(formElementsData[field]);
      });
      return;
    }

    static validateSelectInstance(select) {
      const isSelectInstance = select instanceof Select;

      if (!isSelectInstance)
        throw new Error("Select element must be an instance of Select");
      return;
    }

    static isSelectElement(select) {
      const isInstanceOfSelect = select instanceof Select;

      if (!isInstanceOfSelect)
        throw new Error("Select element must be of Select instance.");
      return;
    }

    static isContactInputInstance(element) {
      const isElementContactInputInstance = element instanceof ContactInput;

      if (!isElementContactInputInstance)
        throw new Error("Form inputs must be of ContactInput instance");
      return;
    }

    static validatePostOutcomeMessage(id) {
      PrimitivesValidator.validateString(id);

      const element = document.getElementById(`${id}`);
      if (!element) console.error(`No element of ${id} was found`);

      const hasInactiveClass = element.classList.contains("inactive");
      if (!hasInactiveClass)
        throw new Error("Form message has to contain inactive class");

      return;
    }

    static validateFormButton(id) {
      PrimitivesValidator.validateString(id);

      const button = document.getElementById(`${id}`);
      if (!button) console.error(`No element of ${id} was found`);

      return;
    }

    static validateFormElement(id) {
      PrimitivesValidator.validateString(id);

      const form = document.getElementById(`${id}`);
      if (!form) console.error(`No element of ${id} was found`);

      const isHTMLFormInstance = form instanceof HTMLFormElement;
      if (!isHTMLFormInstance) throw new Error("Form has to be an html form");
      return;
    }
  }

  class ContactForm {
    constructor(id, formElementsData) {
      PrimitivesValidator.validateString(id);
      ContactFormValidator.validateFormElementsData(formElementsData);
      ContactFormValidator.isContactInputInstance(formElementsData.formName);
      ContactFormValidator.isContactInputInstance(formElementsData.formEmail);
      ContactFormValidator.isContactInputInstance(formElementsData.formMessage);
      PrimitivesValidator.validateString(formElementsData.successMessageId);
      ContactFormValidator.validatePostOutcomeMessage(
        formElementsData.successMessageId
      );
      PrimitivesValidator.validateString(formElementsData.errorMessageId);
      ContactFormValidator.validatePostOutcomeMessage(
        formElementsData.errorMessageId
      );
      ContactFormValidator.isSelectElement(formElementsData.select);
      PrimitivesValidator.validateString(formElementsData.buttonId);
      ContactFormValidator.validateFormButton(formElementsData.buttonId);
      ContactFormValidator.validateFormElement(id);

      this.id = id;
      this.formName = formElementsData.formName;
      this.formEmail = formElementsData.formEmail;
      this.formMessage = formElementsData.formMessage;
      this.successMessageId = formElementsData.successMessageId;
      this.successMessageInactiveClass = "inactive";
      this.successMessage = null;
      this.errorMessageId = formElementsData.errorMessageId;
      this.errorMessageInactiveClass = "inactive";
      this.errorMessage = null;
      this.select = formElementsData.select;
      this.buttonId = formElementsData.buttonId;
      this.button = null;
      this.form;
      this.isValid = false;
      this.invalidElements = [];
      this.initiate();
    }

    _setElement(elementName, id) {
      const element = document.getElementById(id);

      this[elementName] = element;
      return;
    }

    initiate() {
      this._setElement("form", this.id);
      this._setElement("button", this.buttonId);
      this._setElement("successMessage", this.successMessageId);
      this._setElement("errorMessage", this.errorMessageId);
      this._addGetValidity();
      this.handleButtonClick();
    }

    _getSelectValidity() {
      const isValid = this.select.isValid;
      const selectId = this.select.id;
      const indexInInvalidElements = this.invalidElements.indexOf(selectId);
      const isSelectMarkedInvalid = indexInInvalidElements > -1;
      const shouldBeRemovedFromInvalidElements =
        isValid && isSelectMarkedInvalid;
      const shouldBeAddedToInvalidElements =
        !isValid && !isSelectMarkedInvalid;

      if (shouldBeRemovedFromInvalidElements) {
        this.invalidElements.splice(indexInInvalidElements, 1);
        return;
      }

      if (shouldBeAddedToInvalidElements)
        this.invalidElements = [...this.invalidElements, selectId];
        this.updateValidity();
      return;
  
    }

    _getAdditionalInputValidity(event) {
      const inputId = event.target.id;
      const indexInInvalidElements = this.invalidElements.indexOf(inputId);
      const wasInputErrorDetected = indexInInvalidElements > -1;
      const { isActive, isValid, id } = this.select.conditionalInput;

      if (!isActive) {
        if (!wasInputErrorDetected) {
          this.updateValidity();
          return;
        }

        this.invalidElements.splice(indexInInvalidElements, 1);
        return;
      }

      if (!isValid) {
        if (wasInputErrorDetected) return;
        this.invalidElements.push(id);
      }

      if (wasInputErrorDetected)
        this.invalidElements.splice(indexInInvalidElements, 1);
      this.updateValidity();
      return;
    }

    _getInputValidity(event) {
      const inputId = event.target.id;

      const isValid = this[inputId].isValid;

      const indexOfInputInInvalidElements =
        this.invalidElements.indexOf(inputId);
      const isElementAlreadyInvalid = indexOfInputInInvalidElements > -1;

      if (!isValid) {
        if (isElementAlreadyInvalid) return;
        this.invalidElements.push(inputId);
      }

      if (isElementAlreadyInvalid) {
        this.invalidElements.splice(indexOfInputInInvalidElements, 1);
      }

      this.updateValidity();

      return;
    }

    _addGetValidity() {
      const activeInputs = [this.formName, this.formEmail, this.formMessage];

      activeInputs.forEach((input) =>
        input.element.addEventListener(
          "blur",
          this._getInputValidity.bind(this)
        )
      );
      this.select.conditionalInput.element.addEventListener(
        "blur",
        this._getAdditionalInputValidity.bind(this)
      );
      this.select.dropdown.radioButtons.forEach((radioButton) => {
        radioButton.addEventListener(
          "click",
          this._getSelectValidity.bind(this)
        );
      });

      return;
    }

    updateValidity() {
      const hasAnyErrorOccurred = this.invalidElements.length > 0;
      const conditionalInput = this.select.conditionalInput;
      const isOtherSubjectActive = conditionalInput.isActive;



      if (isOtherSubjectActive && !conditionalInput.isValid) {
        this.button.disabled = true;
        return;
      }

      const mandatoryElements = [
        this.formEmail,
        this.formMessage,
        this.formName,
        this.select,
      ];

      const isInvalid = (element) => !element.isValid;

      const isAnyElementInvalid = mandatoryElements.some((element) => isInvalid(element)
      );

      if(hasAnyErrorOccurred && !this.button.disabled){
        this.button.disabled = true;
        return;
      }

      if (!isAnyElementInvalid && !hasAnyErrorOccurred)
        this.button.disabled = false;
      return;
    }

    reset() {
      const conditionalInput = this.select.conditionalInput;
      const mandatoryElements = [
        this.formEmail,
        this.formMessage,
        this.formName,
        this.select,
       
      ];

      mandatoryElements.forEach((element) => element.reset());

      const isOtherSubjectActive = conditionalInput.isActive;
      if (isOtherSubjectActive) conditionalInput.reset();
      this.isValid = false;
      this.button.disabled = true

      return;
    }

    async _handleSubmit(event) {
      event.preventDefault();

      const subject =
        this.select.value.innerHTML === "Other"
          ? this.select.conditionalInput.value
          : this.select.value.innerHTML;
      const name = this.formName.value;
      const email = this.formEmail.value;
      const message = this.formMessage.value;

      

     const data = {
      "request": {
        "requester": {"name": name, "email": email},
        "subject": subject,
        "comment": {"body": message }
      }
    }

    const request= JSON.stringify(data);
    

      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: request,
      };

      try {
        await fetch(
          `https://paul-rich.zendesk.com/api/v2/requests.json`,
          requestOptions
        );

        this.successMessage.classList.remove("inactive");

        const timeoutDuration = 10000;

        setTimeout(() => {
          this.successMessage.classList.add("inactive");
        }, timeoutDuration);
      } catch (error) {
        console.error(error);
        this.errorMessage.classList.remove("inactive");
      } finally {
        this.reset();
      }
    }

    handleButtonClick() {
      this.form.addEventListener("submit", this._handleSubmit.bind(this));
    }
  }

  const formName = new ContactInput("formName");
  const formEmail = new ContactInput("formEmail");
  const formMessage = new ContactInput("formMessage");
  const otherSubject = new ConditionalInput(
    "customSubject",
    "otherSubject",
    "inactive"
  );
  const selectDropdown = new SelectDropdown(
    "select-checkbox",
    "selectOptionsContainer",
    "inactive"
  );
  const select = new Select(selectDropdown, otherSubject, selectData);

  const formElements = {
    formName: formName,
    formEmail: formEmail,
    formMessage: formMessage,
    select: select,
    buttonId: "submitButton",
    successMessageId: "successMessage",
    errorMessageId: "errorMessage",
  };

  new ContactForm("contactForm", formElements);
});
